// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const Criteria = t.struct({
    historyToDisplay: t.maybe(t.Number)
}, 'Criteria');

export const getDefaultState = () =>
    new Criteria({
        historyToDisplay: 90
    });

export default Criteria;



// WEBPACK FOOTER //
// ./src/reports/settlement-no-registration/state/criteria.js